import { Loader2Icon } from "lucide-react";

export const SelectorPickerBadge: React.FC<{ isLoading: boolean; onCancel: () => void }> = ({
  isLoading,
  onCancel,
}) => {
  return (
    <div
      style={{
        position: "fixed",
        pointerEvents: "auto",
        top: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "rgba(0,0,0,0.7)",
        color: "white",
        padding: "4px 8px",
        borderRadius: "5px",
        zIndex: 2147483647,
        display: "flex",
        alignItems: "center",
        gap: "10px",
        fontSize: "12px",
      }}
    >
      {isLoading ? (
        <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "4px 8px" }}>
          <Loader2Icon style={{ width: 16, height: 16, animation: "spin 1s linear infinite" }} />
          <span style={{ fontSize: "12px" }}>Updating...</span>
        </div>
      ) : (
        <>
          <span style={{ fontSize: "12px" }}>Pick an element</span>
          <button
            onClick={onCancel}
            style={{
              background: "transparent",
              border: "1px solid white",
              color: "white",
              borderRadius: "3px",
              cursor: "pointer",
              height: "auto",
              width: "auto",
              padding: "4px 8px",
              fontSize: "12px",
            }}
          >
            Cancel
          </button>
        </>
      )}
    </div>
  );
};
